export const sortColumnsByOrder = (columns) => {
  if (!Array.isArray(columns)) return columns;
  return [...columns].sort((a, b) => {
    const orderA = a.order !== undefined ? a.order : 999;
    const orderB = b.order !== undefined ? b.order : 999;
    return orderA - orderB;
  });
};

export const findColumnIndexByKey = (flatColumns, key) => {
  for (let i = 0; i < flatColumns.length; i++) {
    if (flatColumns[i].key === key) return i;
  }
  return -1;
};

export const findFirstAggregationColumnIndex = (flatColumns) => {
  for (let i = 0; i < flatColumns.length; i++) {
    if (flatColumns[i].type === 'aggregation') return i;
  }
  return -1;
};